import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography'

import SearchInput from '../SearchInput';

const ReferralSearchContent = ({ referrals = [], courtCases = [], onSelect }) => {
    const [filters, setFilters] = useState([])

    return (
        <Grid container direction="column" spacing={1}>
            <Grid item>
                <Typography variant="h6" color="initial">Search Referrals</Typography>
            </Grid>
            <Grid item>
                <SearchInput onChange={setFilters} />
            </Grid>
            <Grid item>
                <List disablePadding>
                    {
                        referrals
                            .map(referral => {
                                const { courtCaseId = '' } = referral || {};
                                const { serviceUserName = '', court = {}, courtCaseNumber = '' } = courtCases.find(({ id }) => id === courtCaseId) || {};

                                return {...referral, serviceUserName, courtCaseNumber, court}
                            })
                            .filter(referral => filters.every(rx => rx.test(`${referral.bookingReference} ${referral.serviceUserName} ${referral.courtCaseNumber}`)))
                            .map(referral => {
                                const { id: referralId, bookingReference, serviceUserName, courtCaseNumber } = referral;

                                return <ListItem
                                    onClick={() => onSelect(referral)}
                                    button
                                    key={referralId}
                                >
                                    <ListItemText primary={serviceUserName} secondary={`${courtCaseNumber} ${bookingReference}`} />
                                </ListItem>
                            })
                    }
                </List>
            </Grid>
        </Grid>
    );
};

export default ReferralSearchContent;